import { api } from '../../api'
import type {
  ClockInOutPayload,
  HourRegistrationExpanded,
  HourRegistrationListResponse,
  HourRegistrationQueryParams,
  ManualHourRegistrationPayload,
  Retainer,
  RetainerListResponse,
  RetainerPayload,
  RetainerQueryParams,
} from '../../../types/hourRegistrations.types'

// ── Clock In/Out ─────────────────────────────────

export const clockIn = async (data: ClockInOutPayload): Promise<HourRegistrationExpanded> => {
  const res = await api.post<HourRegistrationExpanded>('user/clock-in/', data)
  return res.data
}

export const clockOut = async (data: ClockInOutPayload): Promise<HourRegistrationExpanded> => {
  const res = await api.post<HourRegistrationExpanded>('user/clock-out/', data)
  return res.data
}

export const getClockStatus = async (userId: string): Promise<HourRegistrationExpanded | null> => {
  const res = await api.get<HourRegistrationListResponse>('user/hour_registrations/', {
    params: {
      open: true,
      page_size: 1,
      user: userId,
      expand: 'member,brand',
    },
  })
  if (res.data.data.length > 0) {
    return res.data.data[0]
  }
  return null
}

// ── Hour Registrations CRUD ──────────────────────

export const getHourRegistrations = async (params: HourRegistrationQueryParams): Promise<HourRegistrationListResponse> => {
  const res = await api.get<HourRegistrationListResponse>('user/hour_registrations/', { params })
  return res.data
}

export const createHourRegistration = async (data: ManualHourRegistrationPayload): Promise<HourRegistrationExpanded> => {
  const res = await api.post<HourRegistrationExpanded>('user/hour_registrations/', data)
  return res.data
}

export const updateHourRegistration = async (
  id: string | number,
  data: Partial<ManualHourRegistrationPayload>,
): Promise<HourRegistrationExpanded> => {
  const res = await api.patch<HourRegistrationExpanded>(`user/hour_registrations/${id}/`, data)
  return res.data
}

export const deleteHourRegistration = async (id: string | number): Promise<void> => {
  await api.delete(`user/hour_registrations/${id}/`)
}

// ── Retainers CRUD ───────────────────────────────

export const getRetainers = async (params: RetainerQueryParams): Promise<RetainerListResponse> => {
  const res = await api.get<RetainerListResponse>('user/retainers/', { params })
  return res.data
}

export const createRetainer = async (data: RetainerPayload): Promise<Retainer> => {
  const res = await api.post<Retainer>('user/retainers/', data)
  return res.data
}

export const updateRetainer = async (id: string | number, data: Partial<RetainerPayload>): Promise<Retainer> => {
  const res = await api.patch<Retainer>(`user/retainers/${id}/`, data)
  return res.data
}

export const deleteRetainer = async (id: string | number): Promise<void> => {
  await api.delete(`user/retainers/${id}/`)
}
